import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path d="M11 18H13V16H11V18ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 6C9.79 6 8 7.79 8 10H10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 12 11 11.75 11 15H13C13 12.75 16 12.5 16 10C16 7.79 14.21 6 12 6Z" />
);

const smallIcon = (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M8 13.87C11.2419 13.87 13.87 11.2419 13.87 8C13.87 4.75809 11.2419 2.13 8 2.13C4.75809 2.13 2.13 4.75809 2.13 8C2.13 11.2419 4.75809 13.87 8 13.87ZM8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM6.85858 5.58019C6.64258 5.88018 6.56506 6.25714 6.56506 6.50006C6.56506 6.8121 6.3121 7.06506 6.00006 7.06506C5.68802 7.06506 5.43506 6.8121 5.43506 6.50006C5.43506 6.07631 5.55753 5.45327 5.94154 4.91993C6.34629 4.35777 7.01591 3.93506 8.00006 3.93506C8.96754 3.93506 9.63542 4.32031 10.0468 4.85176C10.438 5.35712 10.5651 5.95109 10.5651 6.36023C10.5651 6.90444 10.3921 7.31316 10.1134 7.63276C9.88956 7.88935 9.60144 8.07724 9.38493 8.21842L9.38493 8.21843C9.35929 8.23514 9.33467 8.2512 9.31127 8.26664C9.06313 8.4304 8.89228 8.55838 8.77082 8.72679C8.6612 8.8788 8.56506 9.10331 8.56506 9.50006C8.56506 9.8121 8.3121 10.0651 8.00006 10.0651C7.68802 10.0651 7.43506 9.8121 7.43506 9.50006C7.43506 8.8968 7.58892 8.43382 7.85429 8.06583C8.10784 7.71425 8.43698 7.48973 8.68885 7.32352L8.75067 7.28277L8.75068 7.28277C8.99331 7.123 9.14655 7.0221 9.26176 6.89C9.35801 6.77965 9.43506 6.63593 9.43506 6.36023C9.43506 6.14931 9.36207 5.81319 9.15328 5.54348C8.9647 5.29987 8.63258 5.06506 8.00006 5.06506C7.3842 5.06506 7.05383 5.30901 6.85858 5.58019ZM8.02505 12.45C8.42546 12.45 8.75005 12.1254 8.75005 11.725C8.75005 11.3246 8.42546 11 8.02505 11C7.62464 11 7.30005 11.3246 7.30005 11.725C7.30005 12.1254 7.62464 12.45 8.02505 12.45Z"
  />
);

export const HelpIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="Help" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
